/* ============================================================
   INVINCE — wishlist.js
   Lightweight localStorage "Saved" list. No app required.
   Toggled from product cards + PDP; rendered on /pages/saved.
   ============================================================ */
(function () {
  'use strict';
  var KEY = 'invince-saved';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  function has(handle) { return read().indexOf(handle) !== -1; }

  function setHeart(el, on) {
    var svg = el.querySelector('svg');
    if (svg) svg.setAttribute('fill', on ? 'currentColor' : 'none');
    el.classList.toggle('is-saved', on);
  }

  function paint() {
    var list = read();
    document.querySelectorAll('[data-save]').forEach(function (el) {
      setHeart(el, list.indexOf(el.getAttribute('data-save')) !== -1);
    });
    document.querySelectorAll('[data-saved-count]').forEach(function (el) {
      el.textContent = list.length;
    });
    // Saved page
    var page = document.querySelector('[data-saved-page]');
    if (page) {
      var any = false;
      page.querySelectorAll('[data-saved-card]').forEach(function (card) {
        var on = list.indexOf(card.getAttribute('data-saved-card')) !== -1;
        card.style.display = on ? '' : 'none';
        if (on) any = true;
      });
      var empty = page.querySelector('[data-saved-empty]');
      var grid = page.querySelector('[data-saved-grid]');
      if (empty) empty.style.display = any ? 'none' : '';
      if (grid) grid.style.display = any ? '' : 'none';
    }
  }

  function toggle(el) {
    var handle = el.getAttribute('data-save');
    if (!handle) return;
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle); else list.splice(i, 1);
    write(list);
    paint();
  }

  window.InvinceWishlist = { toggle: toggle, has: has, read: read };

  document.addEventListener('DOMContentLoaded', paint);
  // Repaint after drawer/section refreshes
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-save-remove]')) {
      var h = e.target.closest('[data-save-remove]').getAttribute('data-save-remove');
      var list = read(); var i = list.indexOf(h);
      if (i !== -1) { list.splice(i, 1); write(list); paint(); }
    }
  });
})();
